import React from 'react'
import './Footer.css'
import { Container, Col, Row } from 'reactstrap';
import heart from '../Image/heart.png'

export default function Footer() {
  return (
    <div>
           <footer className="footer">
                <Container>
                    <Row>
                        <Col>
                            <p className="footer-text">Contact Us: +919450-141680, +919935-956663, +918887-781994 <br />
                                Address:  117/L/420 L Block, P Block, Navin Nagar, Kakadeo, Kanpur, Uttar Pradesh 208025<br />
                                <p>&copy; COPYRIGHT 2022 reserved by Vidya Hostel</p>
                                Made with <img src={heart} alt="Heart" style={{ height: "22px", padding: "0 3px", float: "none" }} /> from
                                <a style={{ display: "inline", float: "none", color: "yellow" }} href="#/"> Himanshu Sengar</a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
    </div>
  )
}
